<div *ngIf="hasEnrolmentToken">
    <span class="cert" (click)="downloadCert()"></span>
    <span class="qr icon-qr" *ngIf="!item.enrollmentJwt" (click)="showQRCode()"></span>
</div>
<div *ngIf="!hasEnrolmentToken">
    --
</div>